module.exports = __webpack_public_path__ + "img/star_2.f68dc63a.png";